import axios from 'axios';
import { getToken } from '../../utils/auth';

const token = getToken();

const baseURL = `${process.env.REACT_APP_API_URL ?? 'http://localhost:8000/'}`;

const axiosRequest = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    Accept: '*/*',
  },
});

axiosRequest.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers ? (config.headers['Authorization'] = `Bearer ${token}`) : null;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosRequest;
